var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-block"},[_c('div',{staticClass:"header-block"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.error)?_c('router-link',{attrs:{"to":{ name: 'register' }}},[_vm._v("สมัครสมาชิก")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }